var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',[_c('a',{attrs:{"target":"blank","href":"http://www.beian.miit.gov.cn"}},[_vm._v("Copyright © 2001-2020 "+_vm._s(_vm.$root.siteInfo.websiteCaseBumber)+"粤ICP备 10096701 号  |  法律声明  |  联系我们")])])])}
var staticRenderFns = []

export { render, staticRenderFns }